<template>
  <div class="Comment-Status">
    <button
      class="Comment-Status-Button"
      title="Later"
      :disabled="isDemo"
      @click="$emit('update-status', 'todo')"
    >
      <BIconClockFill :style="`color: ${status === 'todo' ? 'darkorange' : 'lightgray'};`" />
    </button>
    <button
      class="Comment-Status-Button"
      title="Afgehandeld"
      :disabled="isDemo"
      @click="$emit('update-status','done')"
    >
      <BIconCheckCircleFill :style="`color: ${status === 'done' ? 'green' : 'lightgray'};`" />
    </button>
    <button
      class="Comment-Status-Button"
      title="Negeren"
      :disabled="isDemo"
      @click="$emit('update-status', 'ignore')"
    >
      <BIconXCircleFill :style="`color: ${status === 'ignore' ? 'red' : 'lightgray'};`" />
    </button>
  </div>
</template>

<script>
import { BIconClockFill, BIconCheckCircleFill, BIconXCircleFill } from 'bootstrap-vue'

export default {
  components: {
    BIconClockFill,
    BIconCheckCircleFill,
    BIconXCircleFill,
  },
  props: {
    isDemo: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    status: {
      type: String,
      required: false,
      default: () => 'new',
    },
  },
}
</script>

<style lang="scss">
.Comment {
  &-Status {
    display: flex;
    justify-content: flex-end;

    &-Button {
      background: none;
      border: none;
      padding: 0;
      margin: 0 0.4rem;
      font-size: 1.2rem;
    }
  }
}
</style>
